import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isCalculator',
})
export class IsCalculatorPipe implements PipeTransform {
  transform(user: any): boolean {
    if (!user) {
      return false;
    }
    const { claims } = user;
    if (!claims.calculator) {
      return false;
    }

    return true;
  }
}
